import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// `commerce: true` marks answers that describe paying/checkout. Those are
// hidden inside the native app, where no purchase surfaces may appear.
const FAQS: { q: string; a: string; commerce?: boolean }[] = [
  {
    q: "Is Recovery Trauma™ therapy?",
    a: "No. Recovery Trauma™ is an educational and supportive trauma-recovery platform. It does not replace therapy, medical treatment or professional mental-health care.",
  },
  {
    q: "Do I need a PTSD or C-PTSD diagnosis?",
    a: "No. You do not need a diagnosis to use Recovery Trauma™.",
  },
  {
    q: "Can I use Recovery Trauma™ outside the UK?",
    a: "Yes. Recovery Trauma™ is an online platform and can be accessed internationally.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. You can cancel your membership at any time from your billing page. You'll keep full access until the end of the membership period you've already paid for, and there is no cancellation fee.",

  },
  {
    q: "What happens after I join?",
    a: "After creating your account and completing membership checkout, you can access the member area and begin exploring the available resources.",
    commerce: true,
  },
  {
    q: "Can I pay with PayPal?",
    a: "Yes, where PayPal is available as a checkout option.",
    commerce: true,
  },
];

/** Short reassurance accordion, placed immediately before the final join CTA. */
export function HomeFaq() {
  return (
    <section aria-labelledby="home-faq-heading" className="space-y-4">
      <header className="mx-auto max-w-2xl text-center">
        <h2
          id="home-faq-heading"
          className="font-display text-xl leading-tight tracking-tight text-foreground sm:text-2xl"
        >
          Questions Before You Join?
        </h2>
      </header>

      <Accordion
        type="single"
        collapsible
        className="mx-auto w-full max-w-3xl rounded-[22px] border border-gold/25 bg-card/80 px-4 sm:px-6"
      >
        {FAQS.map((item, i) => (
          <AccordionItem
            key={item.q}
            value={`faq-${i}`}
            className="border-gold/20"
            {...(item.commerce ? { "data-commerce": "" } : {})}
          >
            <AccordionTrigger className="text-start font-display text-[15px] leading-snug text-foreground">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-[13.5px] leading-relaxed text-muted-foreground">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="flex justify-center">
        <Link
          to="/faq"
          className="group inline-flex min-h-[48px] items-center gap-2 rounded-full border border-gold/50 bg-background px-6 text-sm font-medium text-foreground transition hover:-translate-y-0.5 hover:bg-gold/10"
        >
          View All FAQs
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </Link>
      </div>
    </section>
  );
}
